import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const SkeletonNumberedProducts = () => {
    return (
        <div className="skeleton-numbered-products-wrapper xmt-20">
            <div className="container">
                <div className="header-slider">
                    <div className="more-icon d-flex justify-content-end"><IconName name="chevron_left"
                                                                                    className="icon"/></div>
                    <div className="border-slider position-relative">
                        <div className="active-slider position-absolute"></div>
                    </div>
                </div>
                <div className="slider-wrapper d-flex align-items-center xmt-6">
                    <div className="slide-box position-relative">
                        <div className="number-slide position-absolute" style={{zIndex:101}}>1</div>
                        <div className="slider skeleton-loading" style={{zIndex:100}}></div>
                    </div>
                    <div className="slide-box position-relative">
                        <div className="number-slide position-absolute" style={{zIndex:99}}>2</div>
                        <div className="slider skeleton-loading" style={{zIndex:98}}></div>
                    </div>
                    <div className="slide-box position-relative">
                        <div className="number-slide position-absolute" style={{zIndex:97}}>3</div>
                        <div className="slider skeleton-loading" style={{zIndex:96}}></div>
                    </div>
                    <div className="slide-box position-relative">
                        <div className="number-slide position-absolute" style={{zIndex:95}}>4</div>
                        <div className="slider skeleton-loading" style={{zIndex:94}}></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonNumberedProducts;
